import React from 'react';
import STRINGS from 'constants/strings';

// Dont blur input when there's a mouseclick on the search suggestions
const preventDefault = evt => {
    evt.preventDefault();
};

// https://github.com/facebook/react/issues/3386#issuecomment-291152357
const HighlightWord = ({ text, query = '', className = '' }) => {
    if (!text) {
        return;
    }
    if (!query) {
        return <span className={className}>{text}</span>;
    }
    return (
        <span className={`font-weight-bold ${className}`}>
            {text.split(query).reduce((prev, current, i) => {
                if (!i) {
                    return [current];
                }
                return prev.concat(
                    <span
                        className={`font-weight-normal`}
                        key={query + current}>
                        {query}
                    </span>,
                    current
                );
            }, [])}
        </span>
    );
};

export const PreviousSearchesListItem = ({
    item,
    changeSearchTerm,
    searchTerm,
    isSelected,
    selectedCategoryId
}) => {
    return (
        <a
            data-suggestion
            className={`list-group-item list-group-item-action slim-header__search-suggestion ${
                isSelected ? 'slim-header__search-suggestion--active' : ''
            }`}
            data-previous-suggestion={item.key}
            onClick={changeSearchTerm}
            onMouseDown={preventDefault}
            data-ga-category="Search Box"
            data-ga-action="Navigation"
            data-ga-label="recent suggestion"
            href={`/search?q=${encodeURIComponent(item.key)}&categoryId=${
                selectedCategoryId ? selectedCategoryId : 0
            }`}>
            <HighlightWord
                className="clock--before ss-fix--before slim-header__search-suggestion-label"
                query={searchTerm}
                text={item.key}
            />
        </a>
    );
};

export const SearchesSuggestionsListItem = ({
    item,
    changeSearchTerm,
    searchTerm,
    isSelected,
    selectedCategoryId
}) => {
    const categoryId = item.category
        ? item.category.id
        : selectedCategoryId
            ? selectedCategoryId
            : 0;

    return (
        <a
            data-suggestion
            className={`list-group-item list-group-item-action slim-header__search-suggestion ${
                isSelected ? 'slim-header__search-suggestion--active' : ''
            }`}
            data-search-suggestion={item.text}
            onClick={changeSearchTerm}
            onMouseDown={preventDefault}
            data-ga-category="Search Box"
            data-ga-action="Navigation"
            data-ga-label={`${
                item.category ? 'category suggestion' : 'normal suggestion'
            }`}
            href={`/search?q=${encodeURIComponent(
                item.text
            )}&categoryId=${categoryId}`}>
            <HighlightWord query={searchTerm} text={item.text} />
            <i> {item.category ? `inom ${item.category.name}` : ''}</i>
        </a>
    );
};

export const ShopsSuggestionsListItem = ({
    item,
    changeSearchTerm,
    searchTerm,
    isSelected
}) => (
    <a
        data-suggestion
        className={`list-group-item list-group-item-action slim-header__search-suggestion ${
            isSelected ? 'slim-header__search-suggestion--active' : ''
        }`}
        data-shop-suggestion={item.name}
        onClick={changeSearchTerm}
        onMouseDown={preventDefault}
        data-ga-category="Search Box"
        data-ga-action="Navigation"
        data-ga-label="shop suggestion"
        href={`/profile/items/${item.memberId}/${item.urlName}`}>
        <em className="badge badge-primary mr-2">Butik</em>
        <HighlightWord query={searchTerm} text={item.name} />
    </a>
);

export const AdvancedSearchListItem = ({ isSelected }) => {
    return (
        <a
            href="/search/detailed"
            data-suggestion
            data-advanced-search
            data-ga-category="Header"
            data-ga-action="Navigation"
            data-ga-label="Advanced search"
            className={`list-group-item list-group-item-action slim-header__search-advanced underline slim-header__search-suggestion col-lg-6 col-md-12 col-sm-6 ${
                isSelected ? 'slim-header__search-suggestion--active' : ''
            }`}
            onMouseDown={preventDefault}>
            <span className="slim-header__search-advanced-icon icon icon--filter float-left ss-fix--before" />
            <span className="slim-header__search-advanced-label underline">
                {STRINGS.ADVANCED_SEARCH}
            </span>
        </a>
    );
};

export const SellerSearchListItem = ({ isSelected }) => {
    return (
        <a
            href="/search/detailed/member?itm_source=nav&itm_medium=search-detailed-member"
            data-suggestion
            data-ga-category="Header"
            data-ga-action="Navigation"
            data-ga-label="Seller search"
            className={`list-group-item list-group-item-action slim-header__search-seller underline slim-header__search-suggestion col-lg-6 col-md-12 col-sm-6 ${
                isSelected ? 'slim-header__search-suggestion--active' : ''
            }`}
            onMouseDown={preventDefault}>
            <span className="slim-header__search-seller-icon icon float-left ss-fix--before">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="12"
                    viewBox="0 0 12 12">
                    <path
                        fill="#43BA7A"
                        fillRule="evenodd"
                        d="M11.294 10.632v.442c0 .065-.02.118-.061.159a.216.216 0 0 1-.16.061H.927a.216.216 0 0 1-.159-.061.216.216 0 0 1-.061-.16v-.44c0-.41.137-.754.41-1.036.274-.282.605-.503.993-.662.388-.16.776-.31 1.164-.453.388-.143.72-.33.993-.558.274-.229.41-.502.41-.821a3.649 3.649 0 0 1-.14-.153 4.372 4.372 0 0 1-.32-.466 5.926 5.926 0 0 1-.404-.766 5.684 5.684 0 0 1-.318-1.048 6.139 6.139 0 0 1-.141-1.317c0-.727.26-1.35.778-1.869A2.549 2.549 0 0 1 6 .706c.727 0 1.35.26 1.869.778.519.519.778 1.142.778 1.869 0 .45-.045.886-.135 1.311-.09.425-.2.778-.33 1.06-.131.282-.262.531-.393.748-.13.216-.24.378-.33.484l-.135.147c0 .319.136.592.41.821.274.229.605.415.993.558.388.143.776.294 1.164.453.388.16.719.38.993.662.273.282.41.627.41 1.035z"
                    />
                </svg>
            </span>
            <span className="slim-header__search-advanced-label underline">
                {STRINGS.SELLER_SEARCH}
            </span>
        </a>
    );
};



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/search-suggestion/suggestion-list-items.jsx